import s3Storage from '@happylife-a/s3-storage';
import * as helpers from '../../../helpers';

/**
 * @param {{
 *   SellerImageService: ReturnType<import('../../services/SellerImageService').default>,
 *   AwsS3Service: ReturnType<import('../../services/AwsS3Service').default>,
 * }} param0
 */
export default function sellerImageUseCase({ SellerImageService, AwsS3Service }) {
  const getSellerImages = (variables) => {
    return SellerImageService.getSellerImages(variables);
  };

  const createSellerImage = (input) => SellerImageService.createSellerImage(input);

  const bulkCreateSellerImage = (input) => SellerImageService.bulkCreateSellerImage(input);

  const deleteSellerImage = (id) => SellerImageService.deleteSellerImage(id);

  const updateSellerImageOrdering = (input) => SellerImageService.updateSellerImageOrdering(input);

  const uploadImage = async (file) => {
    const folder = s3Storage.configs.folders.FOLDER_SELLER_IMAGE;
    const { binary, extension } = await helpers.buildBinaryFile(file);

    return AwsS3Service.uploadPublic(binary, {
      folder: folder,
      extension: extension,
    });
  };

  return {
    getSellerImages: getSellerImages,
    createSellerImage: createSellerImage,
    bulkCreateSellerImage: bulkCreateSellerImage,
    deleteSellerImage: deleteSellerImage,
    updateSellerImageOrdering: updateSellerImageOrdering,
    uploadImage: uploadImage,
  };
}
